import React from 'react';
import { Link } from 'react-router-dom';
import { Input } from './ui/input';
import { PaymentBadges } from './PaymentBadges';
import { useCookieConsent } from '../contexts/CookieConsentContext';

export const Footer = () => {
  const { openSettings } = useCookieConsent();
  return (
    <footer className="bg-[#0A0A0A]" data-testid="main-footer">
      {/* Newsletter */}
      <div className="pt-14 pb-10 md:pt-16 md:pb-12" data-testid="newsletter-section">
        <div className="container-custom">
          <div className="max-w-2xl mx-auto text-center">
            <span className="text-[9px] uppercase tracking-[0.35em] text-[#C9A84C] font-semibold">Don't Miss Out</span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold tracking-tight text-white mt-3 mb-4" data-testid="newsletter-title">
              Stay in the Loop
            </h2>
            <p className="text-white/50 text-sm md:text-base mb-8" data-testid="newsletter-subtitle">
              First dibs on new arrivals, exclusive drops, and vintage finds.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto" data-testid="newsletter-form">
              <Input
                type="email"
                placeholder="Your email address"
                className="bg-white/10 border-white/20 text-white placeholder:text-white/40 focus-visible:ring-[#C9A84C] focus-visible:border-[#C9A84C] h-12 flex-1 backdrop-blur-sm"
                data-testid="newsletter-email-input"
              />
              <button
                className="bg-white text-[#0A0A0A] px-8 h-12 text-sm uppercase tracking-widest font-bold hover:bg-[#C9A84C] hover:text-white transition-colors duration-300 shrink-0"
                data-testid="newsletter-submit-button"
              >
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="container-custom"><div className="border-t border-white/10" /></div>

      {/* Links */}
      <div className="py-10 md:py-14">
        <div className="container-custom">
          <div className="grid grid-cols-2 md:grid-cols-12 gap-8">
            <div className="col-span-2 md:col-span-3">
              <div className="flex items-center gap-2.5 mb-4">
                <img
                  src="https://customer-assets.emergentagent.com/job_654bd78e-5e39-4822-a480-29d8c14fa990/artifacts/ow0h2qv9_Black%20and%20White%20Minimalist%20Round%20Beauty%20And%20Spa%20Logo.png"
                  alt="Vintage Wardrobe Co"
                  className="w-10 h-10 rounded-full object-cover bg-white"
                  width={40}
                  height={40}
                  data-testid="footer-logo"
                />
                <h3 className="text-sm font-heading font-bold text-white">Vintage Wardrobe Co</h3>
              </div>
              <p className="text-xs text-white/40 leading-relaxed max-w-xs">
                Curated vintage & streetwear. One-off items sourced with care. Timeless style for the modern wardrobe.
              </p>
            </div>
            <div className="md:col-span-2">
              <h4 className="text-[10px] font-bold uppercase tracking-[0.2em] mb-4 text-white/60">Company</h4>
              <ul className="space-y-2.5">
                <li><Link to="/about" className="text-sm text-white/40 hover:text-white transition-colors duration-300" data-testid="footer-about-link">About Us</Link></li>
                <li><Link to="/contact" className="text-sm text-white/40 hover:text-white transition-colors duration-300" data-testid="footer-contact-us-link">Contact Us</Link></li>
                <li><Link to="/faq" className="text-sm text-white/40 hover:text-white transition-colors duration-300" data-testid="footer-faq-company-link">FAQ</Link></li>
              </ul>
            </div>
            <div className="md:col-span-2">
              <h4 className="text-[10px] font-bold uppercase tracking-[0.2em] mb-4 text-white/60">Shop</h4>
              <ul className="space-y-2.5">
                <li><Link to="/shop?sort=newest" className="text-sm text-white/40 hover:text-white transition-colors duration-300" data-testid="footer-new-in-link">New In</Link></li>
                <li><Link to="/shop?category=vintage" className="text-sm text-white/40 hover:text-white transition-colors duration-300" data-testid="footer-vintage-link">Vintage</Link></li>
                <li><Link to="/shop?category=streetwear" className="text-sm text-white/40 hover:text-white transition-colors duration-300" data-testid="footer-streetwear-link">Streetwear</Link></li>
                <li><Link to="/shop?category=jackets" className="text-sm text-white/40 hover:text-white transition-colors duration-300" data-testid="footer-jackets-link">Jackets</Link></li>
                <li><Link to="/shop?category=tshirts" className="text-sm text-white/40 hover:text-white transition-colors duration-300" data-testid="footer-tshirts-link">T-Shirts</Link></li>
              </ul>
            </div>
            <div className="md:col-span-2">
              <h4 className="text-[10px] font-bold uppercase tracking-[0.2em] mb-4 text-white/60">Help</h4>
              <ul className="space-y-2.5">
                <li><Link to="/shipping-policy" className="text-sm text-white/40 hover:text-white transition-colors duration-300" data-testid="footer-shipping-link">Shipping</Link></li>
                <li><Link to="/returns-policy" className="text-sm text-white/40 hover:text-white transition-colors duration-300" data-testid="footer-returns-link">Returns & Refunds</Link></li>
                <li><Link to="/sizing-guide" className="text-sm text-white/40 hover:text-white transition-colors duration-300" data-testid="footer-sizing-link">Sizing Guide</Link></li>
                <li><Link to="/track-order" className="text-sm text-white/40 hover:text-white transition-colors duration-300" data-testid="footer-track-order-link">Track My Order</Link></li>
              </ul>
            </div>
            <div className="md:col-span-3">
              <h4 className="text-[10px] font-bold uppercase tracking-[0.2em] mb-4 text-white/60">Legal</h4>
              <ul className="space-y-2.5">
                <li><Link to="/privacy-policy" className="text-sm text-white/40 hover:text-white transition-colors duration-300" data-testid="footer-privacy-link">Privacy Policy</Link></li>
                <li><Link to="/cookie-policy" className="text-sm text-white/40 hover:text-white transition-colors duration-300" data-testid="footer-cookie-policy-link">Cookie Policy</Link></li>
                <li><button onClick={openSettings} className="text-sm text-white/40 hover:text-white transition-colors duration-300 text-left btn-icon" style={{ minHeight: 'unset' }} data-testid="footer-cookie-settings-btn">Cookie Settings</button></li>
                <li><Link to="/terms-conditions" className="text-sm text-white/40 hover:text-white transition-colors duration-300" data-testid="footer-terms-link">Terms & Conditions</Link></li>
                <li><Link to="/authenticity" className="text-sm text-white/40 hover:text-white transition-colors duration-300" data-testid="footer-authenticity-link">Authenticity</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-white/10">
        <div className="container-custom py-6">
          <div className="flex flex-col items-center gap-4">
            <PaymentBadges className="justify-center" dark />
            <p className="text-xs text-white/25 tracking-wide">All transactions are secure and encrypted &middot; &copy; {new Date().getFullYear()} Vintage Wardrobe Co</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
